import { render, staticRenderFns } from "./TvtimeImporter.vue?vue&type=template&id=4fe115c8&scoped=true"
import script from "./TvtimeImporter.vue?vue&type=script&setup=true&lang=ts"
export * from "./TvtimeImporter.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TvtimeImporter.vue?vue&type=style&index=0&id=4fe115c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe115c8",
  null
  
)

export default component.exports